export default __webpack_public_path__ + "static/cursor-4442db94215cddc6fcc85b43e3256813.png";